import React, { useCallback, useEffect, useRef, useState } from "react"
import { cancelCateringOtherProduct, cancelCateringProduct, cancelOrder, getAdminLocation, getAllProductsStatus, getCateringOrderStatus, getCateringWithFilter, getTranslationWithPageName, updateCateringOrderStatus, updateCateringOtherProductStatus, updateCateringProductStatus } from "../../services/ApiServices"
import { changeDateRangeValue, changeDateValue, changeLocationValue, changeStatusValue, changeUserValue } from "../../store/slices/CateringOrderInputStatesSlice"
import { changeAllCateringOrderStatusValue, changeAllLocationValue } from "../../store/slices/APIResponseSlice"
import { changeOverviewTranslationValue } from "../../store/slices/TranslationSlice.ts"
import { convertRespArrToLabelObject, getDynamicLabel } from "../../utils/helpers"
import { appName, handleError, timeInterval } from "../../const"
import { useDispatch, useSelector } from "react-redux"
import { PAGE_NAME } from "../../utils/pageName.ts"
import { useReactToPrint } from "react-to-print"
import { Link } from "react-router-dom"
import { Tooltip } from "react-tooltip"
import { toast } from "react-hot-toast"
import DatePicker from "react-datepicker"
import Select from "react-select"
import moment from "moment"
import Loader from "../Loader/Loader"
import "./Overview.scss"

// ==== Imported Image ====
import iconUser from "../../assets/img/icon-user.svg"
import iconPin from "../../assets/img/icon-pin.svg"
import iconEdit from "../../assets/img/icon-edit.svg"

export default function Overview() {
    const selectedCanteenUsers = useSelector((state) => state.InputStates.inputUser)
    const selectedLocation = useSelector((state) => state.InputStates.inputLocation)
    const selectedDate = useSelector((state) => state.InputStates.inputDate)
    const selectedDateRange = useSelector((state) => state.InputStates.inputDateRange)
    const selectedOrderStatus = useSelector((state) => state.InputStates.inputStatus)
    const OverviewTranslation = useSelector((state) => state.Translation.OverviewTranslation)

    const [isLoading, setIsLoading] = useState(false)
    const [isUpdateLoading, setIsUpdateLoading] = useState(false)
    const [isOrdersLoading, setIsOrdersLoading] = useState(false)
    const [filteredData, setFilteredData] = useState()

    const AllCanteenUsers = useSelector((state) => state?.APIResponse?.AllCanteenUsers)
    const AllLocations = useSelector((state) => state?.APIResponse?.AllLocations)
    const AllCateringOrderStatus = useSelector((state) => state?.APIResponse?.AllCateringOrderStatus)

    const [allCateringProductStatus, setAllCateringProductStatus] = useState([])

    const [updateOrderStatus, setUpdateOrderStatus] = useState({ Status: false, Order: null })

    const dispatch = useDispatch()

    const userRef = useRef()
    const locationRef = useRef()
    const printRef = useRef()
    const updateStatusApiStack = useRef(null)

    const iconTime = (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 37 37">
            <g id="icon-clock" transform="translate(1515 -28)">
                <g id="Group_4728" data-name="Group 4728" transform="translate(-1532.174 -105.174)">
                    <path id="Path_5882" data-name="Path 5882" d="M18.264,6.715H16.841v7.921l5.142,2.444.611-1.285-4.33-2.058Z" transform="translate(18.1 137.821)" fill="#c1c1c1" />
                    <path id="Path_5883" data-name="Path 5883" d="M11.8,1.125A10.674,10.674,0,1,0,22.472,11.8,10.674,10.674,0,0,0,11.8,1.125Zm0,19.924A9.251,9.251,0,1,1,21.049,11.8,9.251,9.251,0,0,1,11.8,21.049Z" transform="translate(23.875 139.875)" fill="#c1c1c1" />
                </g>
            </g>
        </svg>

    )

    //Date translation
    const monthNames = [
        getDynamicLabel(OverviewTranslation?.lblLongJan, "January"),
        getDynamicLabel(OverviewTranslation?.lblLongFeb, "February"),
        getDynamicLabel(OverviewTranslation?.lblLongMar, "March"),
        getDynamicLabel(OverviewTranslation?.lblLongApr, "April"),
        getDynamicLabel(OverviewTranslation?.lblLongMay, "May"),
        getDynamicLabel(OverviewTranslation?.lblLongJun, "June"),
        getDynamicLabel(OverviewTranslation?.lblLongJul, "July"),
        getDynamicLabel(OverviewTranslation?.lblLongAug, "August"),
        getDynamicLabel(OverviewTranslation?.lblLongSep, "September"),
        getDynamicLabel(OverviewTranslation?.lblLongOct, "October"),
        getDynamicLabel(OverviewTranslation?.lblLongNov, "November"),
        getDynamicLabel(OverviewTranslation?.lblLongDec, "December"),
    ]

    //Day translation
    const dayNamesShort = [
        getDynamicLabel(OverviewTranslation?.lblShortSun, "Sun"),
        getDynamicLabel(OverviewTranslation?.lblShortMon, "Mon"),
        getDynamicLabel(OverviewTranslation?.lblShortTue, "Tue"),
        getDynamicLabel(OverviewTranslation?.lblShortWed, "Wed"),
        getDynamicLabel(OverviewTranslation?.lblShortThu, "Thu"),
        getDynamicLabel(OverviewTranslation?.lblShortFri, "Fri"),
        getDynamicLabel(OverviewTranslation?.lblShortSat, "Sat"),
    ]

    const locale = {
        localize: {
            day: n => dayNamesShort[n],
            month: n => monthNames[n]
        },
        formatLong: {
            date: () => 'mm/dd/yyyy'
        }
    }
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: `Overview_Report_${moment(selectedDate).format("DD_MM_YYYY")}`,
        onAfterPrint: () => { setIsLoading(false) },
        onBeforeGetContent: () => {
            setIsLoading(true)

            return new Promise((resolve) => {
                resolve()
            })
        },
        onBeforePrint: () => { },
        removeAfterPrint: true
    })

    const setInputValueToRedux = () => {
        dispatch(changeUserValue(selectedCanteenUsers))
        dispatch(changeLocationValue(selectedLocation))
        dispatch(changeDateValue(selectedDate))
        dispatch(changeStatusValue(selectedOrderStatus))
    }

    const cancelProduct = async (order, product) => {
        if (order && product) {
            try {
                setIsLoading(true)

                let response
                if (product?.type === "Other") {
                    response = await cancelCateringOtherProduct(order?.Id, product?.Product?.Id)
                } else {
                    response = await cancelCateringProduct(order?.Id, product?.ProductOrderId ?? 0)
                }

                if (!response) {
                    await GetFilteredData(true)
                    toast.success(getDynamicLabel(OverviewTranslation?.msgSuccessProductStatusUpdate, "Product Status Updated Successfully."))
                } else {
                    handleError(response)
                }
            } catch (error) {
                handleError(error)
            } finally {
                setIsLoading(false)
            }
        }
    }

    const updateProductStatus = async (orderId, product, selectedStatus, index) => {
        if (orderId && product) {
            try {
                setIsLoading(true)

                let response
                if (product?.type === "Other") {
                    response = await updateCateringOtherProductStatus(orderId, product?.Product?.Id, selectedStatus?.Id)
                } else {
                    response = await updateCateringProductStatus(orderId, product?.ProductOrderId, selectedStatus?.Id)
                }

                if (!response) {
                    await GetFilteredData(true)
                    toast.success(getDynamicLabel(OverviewTranslation?.msgSuccessProductStatusUpdate, "Product Status Updated Successfully."))
                } else {
                    handleError(response)
                }
            } catch (error) {
                handleError(error)
            } finally {
                setIsLoading(false)
            }
        }
    }

    const renderProductStatus = (order, product) => {
        return (
            <div className="d-inline-flex btn-toggle btn-toggle-lg me-2 btn-toggle-status btn-toggle-status-2 product-status">
                {allCateringProductStatus && allCateringProductStatus?.length > 0 && (
                    allCateringProductStatus?.map((productStatus, productStatusIndex) => {
                        const currentStatusIndex = allCateringProductStatus?.findIndex((s) => s?.Id === product?.ProductOrderStatus?.Id)
                        const cancelOrder = product?.ProductOrderStatus?.Name?.toLowerCase() === "cancel"

                        const isCancelStatus = productStatus?.Name?.toLowerCase() === "cancel"
                        const isActive = cancelOrder ? isCancelStatus : productStatusIndex <= currentStatusIndex

                        return (
                            <button
                                key={productStatusIndex}
                                type="button"
                                onClick={() => {
                                    document.activeElement.blur()
                                    if (isCancelStatus) {
                                        cancelProduct(order, product)
                                    } else {
                                        updateProductStatus(order?.Id, product, productStatus)
                                    }
                                }}
                                className={`btn btn-primary d-flex justify-content-center align-items-center me-1 status ${isActive ? productStatus?.Name?.toLowerCase() : ""} ${isActive ? "active" : ""}`}
                            >
                                <img
                                    src={isActive ? productStatus?.Icon : productStatus?.IconDisabled}
                                    alt={productStatus?.Name ?? "--"}
                                    style={{ height: "21px", width: "21px", objectFit: "contain" }}
                                />
                            </button>
                        )
                    })
                )}
            </div>
        )
    }

    const orderCancelStatusObjectReplace = useCallback((data) => {
        const replacingCanceledOrderObject = (data ?? [])?.map((order) => ({
            ...order,
            OrderStatus: order?.IsCancelled ? AllCateringOrderStatus.find((data) => data?.Id === 12) : order?.OrderStatus
        }))

        const filterCanceledOrderData = (
            selectedOrderStatus.length === 0 ? (
                replacingCanceledOrderObject
            ) : (replacingCanceledOrderObject.filter(order =>
                selectedOrderStatus.some(status => status.Id === order.OrderStatus.Id)
            ))
        )
        return filterCanceledOrderData
    }, [AllCateringOrderStatus, selectedOrderStatus])

    const UpdateCateringOrderStatus = (cateringOrderId, statusId) => {
        setIsLoading(true)
        updateCateringOrderStatus(cateringOrderId, statusId).then(async (response) => {
            if (!response) {
                toast.success(getDynamicLabel(OverviewTranslation?.msgSuccessOrderUpdate, "Order Updated Successfully."))
                setIsUpdateLoading(true)
                await GetFilteredData()
            } else {
                toast.error(getDynamicLabel(OverviewTranslation?.msgWrnOrderError, "Looks like an Error!"))
            }
        }).catch((error) => {
            handleError(error)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const GetAdminLocation = async () => {
        setIsLoading(true)
        if (AllLocations?.length === 0) {
            await getAdminLocation().then((response) => {
                if (typeof response === "object" && response?.length > 0) {
                    dispatch(changeAllLocationValue(response))
                } else {
                    dispatch(changeAllLocationValue([]))
                    handleError(response)
                }
            }).catch((error) => {
                handleError(error)
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }

    const GetCateringOrderStatus = async () => {
        setIsLoading(true)
        if (AllCateringOrderStatus.length === 0) {
            await getCateringOrderStatus().then((response) => {
                if (typeof response === "object" && response?.length > 0) {
                    dispatch(changeAllCateringOrderStatusValue(response))
                } else {
                    dispatch(changeAllCateringOrderStatusValue([]))
                    handleError(response)
                }
            }).catch((error) => {
                handleError(error)
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }

    const GetFilteredData = useCallback(async () => {
        if (selectedDateRange[0] && selectedDateRange[1]) {
            setIsUpdateLoading(true)

            getCateringWithFilter(
                selectedLocation?.map((d) => d?.Id),
                selectedOrderStatus?.map((d) => d?.Id),
                moment(selectedDateRange[0]).format("YYYY-MM-DD"),
                moment(selectedDateRange[1]).format("YYYY-MM-DD"),
                selectedCanteenUsers?.value ? selectedCanteenUsers?.value : ""
            ).then(async (response) => {
                const timeFilter = response && response.length > 0
                    ? response.sort((a, b) => {
                        const dateA = a?.Meeting
                            ? moment(a?.Meeting?.Start).format("YYYY-MM-DD")
                            : moment(a?.DeliveryDate).format("YYYY-MM-DD");
                        const dateB = b?.Meeting
                            ? moment(b?.Meeting?.Start).format("YYYY-MM-DD")
                            : moment(b?.DeliveryDate).format("YYYY-MM-DD");

                        if (dateA !== dateB) {
                            return dateA > dateB ? 1 : -1;
                        } else {
                            const timeA = a?.Meeting
                                ? moment(a?.Meeting?.Start).format("HH:mm")
                                : `${a?.DeliveryHour}:${a?.DeliveryMinute}`;
                            const timeB = b?.Meeting
                                ? moment(b?.Meeting?.Start).format("HH:mm")
                                : `${b?.DeliveryHour}:${b?.DeliveryMinute}`;
                            return timeA > timeB ? 1 : -1;
                        }
                    })
                    : [];

                const cateringData = timeFilter && timeFilter.length > 0 &&
                    timeFilter?.map((tf) => ({
                        ...tf,
                        ProductOrders: tf?.ProductOrders?.map((d) => ({
                            ...d,
                            DeliveryHour: d?.DeliveryHour === null ? "" : d?.DeliveryHour < 10 ? `0${d?.DeliveryHour}` : `${d?.DeliveryHour}`,
                            DeliveryMinute: d?.DeliveryMinute === null ? "" : d?.DeliveryMinute < 10 ? `0${d?.DeliveryMinute}` : `${d?.DeliveryMinute}`,
                        })),
                        ProductOtherOrders: tf?.ProductOtherOrders?.map((d) => ({
                            DeliveryHour: d?.DeliveryHour === null ? "" : d?.DeliveryHour < 10 ? `0${d?.DeliveryHour}` : `${d?.DeliveryHour}`,
                            DeliveryMinute: d?.DeliveryMinute === null ? "" : d?.DeliveryMinute < 10 ? `0${d?.DeliveryMinute}` : `${d?.DeliveryMinute}`,
                            NumberOfItems: d?.NumberOfItems,
                            Product: { Id: d?.Id, Name: d?.Name, Notes: d?.Name, Price: d?.Price }
                        }))
                    }))

                const sortProdTime = cateringData && cateringData.length > 0 &&
                    cateringData?.map((cd) => ({
                        ...cd,
                        ProductOrders: cd?.ProductOrders?.length > 0
                            ? cd?.ProductOrders?.sort((a, b) => Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`))
                            : [],
                        ProductOtherOrders: cd?.ProductOtherOrders?.length > 0
                            ? cd?.ProductOtherOrders?.sort((a, b) => Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`))
                            : []
                    }))

                setFilteredData(sortProdTime)
            }).catch((error) => {
                setFilteredData([])
                handleError(error)
            }).finally(() => {
                setIsUpdateLoading(false)
            })
        }
    }, [selectedCanteenUsers?.value, selectedDateRange, selectedLocation, selectedOrderStatus])

    // ****************** Cancel Order ******************
    const CancelOrder = useCallback(async (order) => {
        let subscribed = true

        if (order?.Id) {
            const currentCallTime = new Date()
            updateStatusApiStack.current = currentCallTime

            setIsLoading(true)
            setUpdateOrderStatus({ Status: true, Order: order })
            const response = await cancelOrder(order?.Id)
            if (subscribed && updateStatusApiStack.current === currentCallTime) {
                await GetFilteredData()
                if (!response) {
                    toast.success(getDynamicLabel(OverviewTranslation?.msgSuccessOrderUpdate, "Order Status Updated Successfully."))
                } else {
                    handleError(response)
                }
                setUpdateOrderStatus({ Status: false, Order: null })
                setIsLoading(false)
            }
        }

        return () => {
            subscribed = false
        }
    }, [GetFilteredData, OverviewTranslation?.msgSuccessOrderUpdate])

    const GetProductStatus = () => {
        setIsLoading(true)
        getAllProductsStatus().then((response) => {
            if (response) {
                setAllCateringProductStatus(response)
            }
        }).catch((error) => {
            handleError(error)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    // GET ALL ORDERS
    useEffect(() => {

        let subscribed = true

        if (selectedDateRange[0] && selectedDateRange[1]) {
            setIsOrdersLoading(true)
            getCateringWithFilter(
                selectedLocation?.map((d) => d?.Id),
                selectedOrderStatus?.map((d) => d?.Id),
                moment(selectedDateRange[0]).format("YYYY-MM-DD"),
                moment(selectedDateRange[1]).format("YYYY-MM-DD"),
                selectedCanteenUsers?.value ? selectedCanteenUsers?.value : ""
            ).then(async (response) => {
                if (subscribed) {
                    const timeFilter = response && response.length > 0
                        ? response.sort((a, b) => {
                            const momentA = a?.Meeting
                                ? moment(a?.Meeting?.Start)
                                : moment(a?.DeliveryDate).set({
                                    hour: a?.DeliveryHour,
                                    minute: a?.DeliveryMinute,
                                    second: 0,
                                    millisecond: 0
                                });

                            const momentB = b?.Meeting
                                ? moment(b?.Meeting?.Start)
                                : moment(b?.DeliveryDate).set({
                                    hour: b?.DeliveryHour,
                                    minute: b?.DeliveryMinute,
                                    second: 0,
                                    millisecond: 0
                                });

                            // Compare moments directly
                            return momentA.isAfter(momentB) ? 1 : -1;
                        })
                        : [];

                    const cateringData = timeFilter && timeFilter.length > 0 &&
                        timeFilter?.map((tf) => ({
                            ...tf,
                            ProductOrders: tf?.ProductOrders?.map((d) => ({
                                ...d,
                                DeliveryHour: d?.DeliveryHour === null ? "" : d?.DeliveryHour < 10 ? `0${d?.DeliveryHour}` : `${d?.DeliveryHour}`,
                                DeliveryMinute: d?.DeliveryMinute === null ? "" : d?.DeliveryMinute < 10 ? `0${d?.DeliveryMinute}` : `${d?.DeliveryMinute}`,
                            })),
                            ProductOtherOrders: tf?.ProductOtherOrders?.map((d) => ({
                                DeliveryHour: d?.DeliveryHour === null ? "" : d?.DeliveryHour < 10 ? `0${d?.DeliveryHour}` : `${d?.DeliveryHour}`,
                                DeliveryMinute: d?.DeliveryMinute === null ? "" : d?.DeliveryMinute < 10 ? `0${d?.DeliveryMinute}` : `${d?.DeliveryMinute}`,
                                NumberOfItems: d?.NumberOfItems,
                                Product: { Id: d?.Id, Name: d?.Name, Notes: d?.Name, Price: d?.Price }
                            }))
                        }))

                    const sortProdTime = cateringData && cateringData.length > 0 &&
                        cateringData?.map((cd) => ({
                            ...cd,
                            ProductOrders: cd?.ProductOrders?.length > 0
                                ? cd?.ProductOrders?.sort((a, b) => Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`))
                                : [],
                            ProductOtherOrders: cd?.ProductOtherOrders?.length > 0
                                ? cd?.ProductOtherOrders?.sort((a, b) => Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`))
                                : []
                        }))

                    setFilteredData(sortProdTime)
                }
            }).catch((error) => {
                if (subscribed) {
                    setFilteredData([])
                    handleError(error)
                }
            }).finally(() => {
                setIsOrdersLoading(false)
            })
        }

        const interval = setInterval(() => {
            GetFilteredData()
        }, timeInterval)

        return () => {
            clearInterval(interval)
            subscribed = false
            setIsOrdersLoading(false)
        }
    }, [selectedLocation, selectedOrderStatus, selectedDateRange, selectedCanteenUsers, GetFilteredData])

    useEffect(() => {
        GetAdminLocation()
        GetCateringOrderStatus()
        GetProductStatus()
    }, [])

    useEffect(() => {
        setIsLoading(true)
        getTranslationWithPageName(PAGE_NAME?.OVERVIEW, appName).then((response) => {
            if (typeof response === "object" && response?.length >= 0) {
                dispatch(changeOverviewTranslationValue(convertRespArrToLabelObject(response)))
            } else {
                handleError(response)
            }
        }).catch((error) => {
            handleError(error)
        }).finally(() => {
            setIsLoading(false)
        })
    }, [dispatch])

    return (
        <div className="print-fragment" ref={printRef}>
            {(isLoading || isUpdateLoading || isOrdersLoading) && <Loader />}

            {/* ========================== Header Title ========================== */}
            <div className="pagetitle mb-4 d-flex justify-content-between align-items-center overview-group">
                <h1 className="w-auto">{getDynamicLabel(OverviewTranslation?.lblHeadOverview, "Overview")}</h1>
                <button
                    onClick={() => handlePrint()}
                    className="btn btn-sm btn-secondary py-1"
                    style={{ minWidth: "0", color: "#013871", borderRadius: "4px" }}
                >
                    <i className="bi bi-printer" />{getDynamicLabel(OverviewTranslation?.lblPrintReport, "PRINT REPORT")}
                </button>
            </div>

            {/* ========================== Input Section ========================== */}
            <div className="section input-section mb-4">
                <div className="row">
                    <div className="col-6 inputSec-icon mb-3">
                        <Select
                            ref={userRef} openMenuOnFocus={true}
                            value={[selectedCanteenUsers?.value ? selectedCanteenUsers : { value: "", label: getDynamicLabel(OverviewTranslation?.lblSelectUser, "Select User") }]}
                            onChange={(e) => dispatch(changeUserValue(e))}
                            options={AllCanteenUsers?.length > 0
                                ? [
                                    { value: "", label: getDynamicLabel(OverviewTranslation?.lblSelectUser, "Select User") },
                                    ...AllCanteenUsers?.map((data) => ({ value: data?.Email, label: data?.Name }))]
                                : [{ value: "", label: getDynamicLabel(OverviewTranslation?.lblSelectUser, "Select User") }]
                            }
                            className="form-control p-0"
                            placeholder={getDynamicLabel(OverviewTranslation?.lblSelectUser, "Select User")}
                            styles={{
                                control: (baseStyles) => ({
                                    ...baseStyles,
                                    border: "none",
                                    boxShadow: "none",
                                    padding: "8px 10px",
                                    borderRadius: 8,
                                }),
                                container: (baseStyles) => ({
                                    ...baseStyles,
                                    zIndex: 20
                                })
                            }}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: () => null
                            }}
                        />
                        <span onClick={() => userRef.current.focus()}>
                            <img className="p-2" alt="icon-user" src={iconUser} />
                        </span>
                    </div>

                    <div className="col-6 inputSec-icon mb-3">
                        <Select
                            ref={locationRef} openMenuOnFocus={true} isMulti
                            value={selectedLocation?.map((location) => ({ value: location?.Id, label: location?.Name }))}
                            onChange={(e) => dispatch(changeLocationValue(e?.map((d) => ({ Id: d?.value, Name: d?.label }))))}
                            className="form-control p-0"
                            placeholder={getDynamicLabel(OverviewTranslation?.lblSelectLocation, "Select Location")}
                            options={AllLocations?.map((location) => ({ value: location?.Id, label: location?.Name }))}
                            styles={{
                                control: (baseStyles) => ({
                                    ...baseStyles,
                                    border: "none",
                                    boxShadow: "none",
                                    padding: "8px 10px",
                                    borderRadius: 8,
                                }),
                                container: (baseStyles) => ({
                                    ...baseStyles,
                                    zIndex: 25
                                })
                            }}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: () => null
                            }}
                        />
                        <span>
                            <img className="p-2" alt="icon-pin" src={iconPin} />
                        </span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6 mb-3 ">
                        <div className="inputSec-icon">
                            <DatePicker
                                locale={locale}
                                className="form-control"
                                calendarStartDay={1}
                                selectsRange
                                startDate={selectedDateRange[0]}
                                endDate={selectedDateRange[1]}
                                onChange={(date) => dispatch(changeDateRangeValue(date))}
                                dateFormat="dd.MM.yyyy"
                                placeholderText={getDynamicLabel(OverviewTranslation?.lblSelectDateRange, "Select Date Range")}
                            />
                        </div>
                    </div>

                    <div className="col-6 mb-3">
                        <Select
                            isMulti
                            openMenuOnFocus={true}
                            value={selectedOrderStatus?.map((status) => ({ value: status?.Id, label: status?.Name }))}
                            onChange={(e) => dispatch(changeStatusValue(e?.map((d) => ({ Id: d?.value, Name: d?.label }))))}
                            options={AllCateringOrderStatus?.map((status) => ({ value: status?.Id, label: status?.Name }))}
                            className="form-control p-0"
                            placeholder={getDynamicLabel(OverviewTranslation?.lblSelectStatus, "Select Status")}
                            styles={{
                                control: (baseStyles) => ({
                                    ...baseStyles,
                                    border: "none",
                                    boxShadow: "none",
                                    padding: "8px 10px",
                                    borderRadius: 8,
                                }),
                                container: (baseStyles) => ({
                                    ...baseStyles,
                                    zIndex: 20
                                })
                            }}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: () => null
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* ========================== Print Input Details Section ========================== */}
            <div className="section label-section mb-4">
                <div className="row">
                    <div className="col-6 d-inline-flex mb-2">
                        <label className="me-2"><b>{getDynamicLabel(OverviewTranslation?.lblUser, "User")}:</b></label>
                        <span>{selectedCanteenUsers?.value ? selectedCanteenUsers?.value : "- -"}</span>
                    </div>
                    <div className="col-6 d-inline-flex mb-2">
                        <label className="me-2"><b>{getDynamicLabel(OverviewTranslation?.lblLocation, "Location")}:</b></label>
                        <span>{selectedLocation && selectedLocation?.length > 0 ? selectedLocation.map((d) => d?.Name).toString() : "- -"}</span>
                    </div>
                    <div className="col-6 d-inline-flex mb-2">
                        <label className="me-2"><b>{getDynamicLabel(OverviewTranslation?.lblDate, "Date")}:</b></label>
                        <span>{moment(selectedDateRange[0]).format("DD.MM.YYYY") + " To " +
                            moment(selectedDateRange[1]).format("DD.MM.YYYY")}</span>
                    </div>
                    <div className="col-6 d-inline-flex mb-2">
                        <label className="me-2"><b>{getDynamicLabel(OverviewTranslation?.lblStatus, "Status")}:</b></label>
                        <span>{selectedOrderStatus && selectedOrderStatus.length > 0 ? selectedOrderStatus.map((d) => d?.Name).toString() : "- -"}</span>
                    </div>
                </div>
            </div>

            {/* ========================== Catering Cards Section ========================== */}
            <section className="overview-section section mb-4">
                {filteredData?.length > 0 && (
                    orderCancelStatusObjectReplace(filteredData)?.map((cateringOrder, cateringOrderIndex) => {
                        const isOrderStatusUpdating = updateOrderStatus?.Status && updateOrderStatus?.Order?.Id === cateringOrder?.Id
                        // const isUpdating = editedOrder?.Id === order?.Id

                        return (
                            <div key={cateringOrderIndex} className="card prod-card">
                                {(isOrderStatusUpdating) && (
                                    <div className="card-loader">
                                        <span className="spinner-border" role="status">
                                            <span className="visually-hidden">{getDynamicLabel(OverviewTranslation?.Translations?.lblLoading, "Loading...")}</span>
                                        </span>
                                    </div>
                                )}

                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-8 col-sm-12">
                                                <div className="row">
                                                    {/* Time */}
                                                    <div className="print-time col-xl-3 col-lg-3 col-md-6 col-sm-4 mb-2">
                                                        <b className="">
                                                            {cateringOrder?.Meeting !== null ? (
                                                                moment(cateringOrder?.Meeting?.Start).format("DD.MM.YYYY") + " (" +
                                                                moment(cateringOrder?.Meeting?.Start).format("HH:mm") + " - " +
                                                                moment(cateringOrder?.Meeting?.End).format("HH:mm") + ")"
                                                            ) : (
                                                                moment(cateringOrder?.DeliveryDate).format("DD.MM.YYYY")
                                                                // + " (" +
                                                                // moment(`${cateringOrder?.DeliveryHour}:${cateringOrder?.DeliveryMinute}`, "HH:mm").format("HH:mm") + ")"
                                                            )}
                                                        </b>
                                                    </div>

                                                    {/* Title */}
                                                    <div className="print-time col-xl-2 col-lg-2 col-md-6 col-sm-4 mb-2">
                                                        <b className="">
                                                            {cateringOrder?.Meeting?.Id ? (
                                                                cateringOrder?.Meeting?.Title
                                                            ) : cateringOrder?.Title ? (
                                                                `${cateringOrder?.Title} (${getDynamicLabel(OverviewTranslation?.lblPickupOrder, "A Pickup Order")})`
                                                            ) : (
                                                                getDynamicLabel(OverviewTranslation?.lblPickupOrder, "A Pickup Order")
                                                            )}
                                                        </b>
                                                    </div>

                                                    {/* Order Number */}
                                                    <div className="print-ordernumber col-xl-2 col-lg-2 col-md-4 col-4 mb-3">
                                                        <span className="fw-normal">
                                                            <b className="mb-3">{getDynamicLabel(OverviewTranslation?.lblOrderNumber, "Order Number")}:&nbsp;</b>
                                                            {cateringOrder?.OrderNumber ? cateringOrder?.OrderNumber : "- -"}
                                                        </span>
                                                    </div>

                                                    {/* Location(Meeting Room) */}
                                                    <div className="print-location col-xl-2 col-lg-2 col-md-4 col-sm-4 mb-2">
                                                        <b>
                                                            {cateringOrder?.Meeting?.MeetingRooms[0] && cateringOrder?.Meeting?.MeetingRooms[0]?.Location?.Name ? (
                                                                cateringOrder?.Meeting?.MeetingRooms[0]?.Location?.Name + " (" + cateringOrder?.Meeting?.MeetingRooms[0]?.Name + ")"
                                                            ) : (
                                                                <span>
                                                                    {cateringOrder?.Location?.Name ?? ""}
                                                                </span>
                                                            )}
                                                        </b>
                                                    </div>

                                                    {/* Order By */}
                                                    <div className="print-orderby col-xl-3 col-lg-3 col-md-6 col-sm-4 mb-2">
                                                        <span className="fw-normal">
                                                            <b className="mb-3">{getDynamicLabel(OverviewTranslation?.lblOrderedBy, "Ordered by")}:&nbsp;</b>
                                                            {cateringOrder?.OrderedByName}
                                                            {cateringOrder?.OrderedByPhone && `/${cateringOrder?.OrderedByPhone}`}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-between gap-2">
                                                {/* Order Status */}
                                                <div className="row print-orderstatus" style={{ flex: "1", zIndex: "12" }}>
                                                    {AllCateringOrderStatus && AllCateringOrderStatus?.length > 0 && (
                                                        AllCateringOrderStatus?.map((status, statusIndex) => {
                                                            const currentStatusIndex = AllCateringOrderStatus?.findIndex((s) => s?.Id === cateringOrder?.OrderStatus?.Id)
                                                            const cancelOrder = cateringOrder?.IsCancelled

                                                            const isCancelStatus = status?.Name?.toLowerCase() === "cancel"
                                                            const isActive = cancelOrder ? isCancelStatus : statusIndex <= currentStatusIndex

                                                            return (
                                                                <div
                                                                    key={statusIndex}
                                                                    title={status?.Name ?? "--"}
                                                                    onClick={() => {
                                                                        if (isCancelStatus) {
                                                                            CancelOrder(cateringOrder)
                                                                        } else {
                                                                            UpdateCateringOrderStatus(cateringOrder?.Id, status?.Id)
                                                                        }
                                                                    }}
                                                                    className={`col-xl-4 col-lg-12 col-md-12 col-sm-4 mb-2 d-flex overflow-hidden pe-1 ${isActive ? status?.Name?.toLowerCase() : ""} ${isActive ? "active" : ""}`}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {status?.Id === 12
                                                                        ? <i className={`fa-solid fa-circle-xmark d-flex align-items-center me-1 ${status?.Id === cateringOrder?.OrderStatus?.Id ? "text-danger" : "text-secondary"}`} />
                                                                        : <i className={`fa-solid fa-circle-check d-flex align-items-center me-1 ${status?.Id === cateringOrder?.OrderStatus?.Id ? "text-success" : "text-secondary"}`} />
                                                                    }
                                                                    <b>{status?.Name}</b>
                                                                </div>
                                                            )
                                                        })
                                                    )}
                                                </div>

                                                {/* Order Edit Icon */}
                                                <div style={{ zIndex: "12" }}>
                                                    <button
                                                        onClick={() => setInputValueToRedux()}
                                                        className="btn btn-secondary btn-icon mb-2 edit-btn"
                                                    >
                                                        <Link to={`/order-details/${cateringOrder?.Id}`}>
                                                            <img src={iconEdit} alt="icon-edit" />
                                                        </Link>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="row">
                                            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                                                <div className="row">
                                                    {/* Products */}
                                                    <div className="print-products col-xl-5 col-lg-5 col-md-6 col-12 mb-3">
                                                        <b className="mb-3 d-block">
                                                            {getDynamicLabel(OverviewTranslation?.lblProducts, "Products")}
                                                        </b>

                                                        {[...(cateringOrder?.ProductOrders || []), ...(cateringOrder?.ProductOtherOrders || [])]?.length > 0 ? (
                                                            [...cateringOrder?.ProductOrders, ...cateringOrder?.ProductOtherOrders]?.sort((a, b) =>
                                                                Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`)
                                                            )?.map((product, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="row align-items-start g-2 py-1"
                                                                >
                                                                    {/* Product info */}
                                                                    <div className="col-12 col-sm-5 d-flex flex-wrap align-items-center">
                                                                        <span className="fw-semibold">
                                                                            {product?.NumberOfItems} × {product?.Product?.Name}
                                                                        </span>
                                                                    </div>

                                                                    {/* Delivery time */}
                                                                    <div className="col-6 col-sm-3 d-flex align-items-center mt-1 mt-sm-0">
                                                                        {product?.DeliveryHour && (
                                                                            <span
                                                                                className="d-flex justify-content-start align-items-center text-muted small"
                                                                                data-tooltip-place="top"
                                                                                data-tooltip-id={`delivery-time-${index}`}
                                                                                data-tooltip-content={`${cateringOrder?.DeliveryMethod === "Pickup" ? "Pickup time" : "Delivery time"}`}
                                                                            >
                                                                                {iconTime}&nbsp;{product?.DeliveryHour}:{product?.DeliveryMinute}
                                                                            </span>
                                                                        )}
                                                                        <Tooltip id={`delivery-time-${index}`} />
                                                                    </div>

                                                                    {/* Product status */}
                                                                    <div className="col-6 col-sm-4 mt-1 mt-sm-0">
                                                                        {renderProductStatus(cateringOrder, product)}
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-muted">- -</div>
                                                        )}
                                                    </div>

                                                    {/* Delivered By */}
                                                    <div className="print-deliverby col-xl-2 col-lg-2 col-md-4 col-6 mb-2">
                                                        <span className="fw-normal">
                                                            <b className="mb-3">{getDynamicLabel(OverviewTranslation?.lblDeliveredBy, "Delivered by")}:&nbsp;</b>
                                                            {cateringOrder?.CanteenUsers && cateringOrder?.CanteenUsers?.length > 0 ? (
                                                                (`${cateringOrder?.CanteenUsers?.map((canteenUser) => canteenUser?.Name ?? canteenUser?.Email ?? "--")}`)?.split(",").join(", ")
                                                            ) : "--"}
                                                        </span>
                                                    </div>

                                                    {/* Attendees */}
                                                    <div className="print-attendee col-xl-2 col-lg-2 col-md-4 col-6 mb-3">
                                                        <span className="fw-normal">
                                                            <b className="mb-3">{getDynamicLabel(OverviewTranslation?.lblAttendees, "Attendees")}:&nbsp;</b>
                                                            {cateringOrder?.NumberOfPeople + cateringOrder?.ExternalAttendeesPeoples}
                                                        </span>
                                                    </div>

                                                    {/* Comments */}
                                                    <div className="print-comment col-xl-3 col-lg-3 col-md-4 col-6 mb-3">
                                                        <b className="mb-3">{getDynamicLabel(OverviewTranslation?.lblComments, "Comments")}</b>
                                                        <div dangerouslySetInnerHTML={{ __html: cateringOrder?.CommentHtml?.trim() ? cateringOrder?.CommentHtml : cateringOrder?.Comment ?? "--" }} />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Internal Comments */}
                                            <div className="print-intcomment col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                                <b className="mb-3">{getDynamicLabel(OverviewTranslation?.lblInternalComments, "Internal Comments")}</b><br />
                                                <div dangerouslySetInnerHTML={{ __html: cateringOrder?.InternalCommentHtml?.trim() ? cateringOrder?.InternalCommentHtml : cateringOrder?.InternalComment ?? "--" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {cateringOrder?.IsCancelled && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgba(255, 255, 255, 0.6)', // Optional: semi-transparent overlay
                                            zIndex: 10,
                                            cursor: 'not-allowed',
                                        }}
                                    />
                                )}
                            </div>
                        )
                    })
                )}
            </section>

            {/* ========================== Print Catering Cards Section ========================== */}
            <section className="print-overview-section section mb-4">
                {filteredData?.length > 0 && (
                    orderCancelStatusObjectReplace(filteredData)?.filter(
                        (d) => !d?.IsCancelled && (d?.ProductOrders?.some((p) => p?.ProductOrderStatus?.Name?.toLowerCase() !== "cancel") || d?.ProductOtherOrders?.some((p) => p?.ProductOrderStatus?.Name?.toLowerCase() !== "cancel"))
                    )?.map((cateringOrder, cateringOrderIndex) =>
                        <div key={cateringOrderIndex} className="card prod-card mb-2">
                            <div className="row d-flex flex-wrap mb-2">
                                {/* Column 1 */}
                                <div className="col-lg-5 col-md-5 col-sm-5">
                                    {/* Order Number */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblOrderNumber, "Order Number")}: &nbsp;</span>
                                        {cateringOrder?.OrderNumber ? cateringOrder?.OrderNumber : "- -"}
                                    </div>

                                    {/* Meeting Title */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblMeetingTitle, "Meeting Title")}: &nbsp;</span>
                                        {cateringOrder?.Meeting?.Id ? (
                                            cateringOrder?.Meeting?.Title
                                        ) : cateringOrder?.Title ? (
                                            `${cateringOrder?.Title} (${getDynamicLabel(OverviewTranslation?.lblPickupOrder, "A Pickup Order")})`
                                        ) : (
                                            getDynamicLabel(OverviewTranslation?.lblPickupOrder, "A Pickup Order")
                                        )}
                                    </div>

                                    {/* Meeting Time */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblMeetingDateTime, "Meeting Date(Time)")}: &nbsp;</span>
                                        {cateringOrder?.Meeting !== null ? (
                                            moment(cateringOrder?.Meeting?.Start).format("DD.MM.YYYY") + " (" +
                                            moment(cateringOrder?.Meeting?.Start).format("HH:mm") + " - " +
                                            moment(cateringOrder?.Meeting?.End).format("HH:mm") + ")"
                                        ) : (
                                            moment(cateringOrder?.DeliveryDate).format("DD.MM.YYYY") + " (" +
                                            moment(`${cateringOrder?.DeliveryHour}:${cateringOrder?.DeliveryMinute}`, "HH:mm").format("HH:mm") + ")"
                                        )}
                                    </div>

                                    {/* Status */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblStatus, "Status")}: &nbsp;</span>
                                        {cateringOrder?.OrderStatus?.Name}
                                    </div>

                                    {/* Attendees */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblAttendees, "Attendees")}: &nbsp;</span>
                                        {cateringOrder?.NumberOfPeople + cateringOrder?.ExternalAttendeesPeoples}
                                    </div>
                                </div>

                                {/* Column 2 */}
                                <div className="col-lg-7 col-md-7 col-sm-7">
                                    {/* Location */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblLocation, "Location")}: &nbsp;</span>
                                        {cateringOrder?.Meeting?.MeetingRooms[0] && cateringOrder?.Meeting?.MeetingRooms[0]?.Location?.Name ? (
                                            cateringOrder?.Meeting?.MeetingRooms[0]?.Location?.Name + " (" + cateringOrder?.Meeting?.MeetingRooms[0]?.Name + ")"
                                        ) : (
                                            <span>{cateringOrder?.Location?.Name}</span>
                                        )}
                                    </div>

                                    {/* Cost Center */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblCostCenter, "Cost Center")}: &nbsp;</span>
                                        {cateringOrder?.Department?.Name}{` (${cateringOrder?.Department?.ManagerName})`}
                                    </div>

                                    {/* Delivered By */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblDeliveredBy, "Delivered by")}: &nbsp;</span>
                                        {cateringOrder?.CanteenUsers && cateringOrder?.CanteenUsers?.length > 0 ? (
                                            (`${cateringOrder?.CanteenUsers?.map((canteenUser) => canteenUser?.Name ?? canteenUser?.Email ?? "--")}`)?.split(",").join(", ")
                                        ) : "--"}
                                    </div>

                                    {/* Ordered By */}
                                    <div>
                                        <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblOrderedBy, "Ordered by")}: &nbsp;</span>
                                        {cateringOrder?.OrderedByName}
                                        {cateringOrder?.OrderedByPhone && `/${cateringOrder?.OrderedByPhone}`}
                                    </div>
                                </div>
                            </div>

                            <div className="row d-flex flex-wrap">
                                {/* Products */}
                                <div className="col-lg-4 col-md-4 col-sm-4">
                                    <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblProducts, "Products")}: &nbsp;</span>
                                    <div>
                                        {[...cateringOrder?.ProductOrders, ...cateringOrder?.ProductOtherOrders]?.length > 0 &&
                                            [...cateringOrder?.ProductOrders, ...cateringOrder?.ProductOtherOrders]?.sort((a, b) =>
                                                Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`)
                                            )?.filter((d) => d?.ProductOrderStatus?.Name?.toLowerCase() !== "cancel")?.map((product, index) =>
                                                <div key={index} className="row align-items-center">
                                                    <div className="col">
                                                        <span className="d-flex">{product?.NumberOfItems} X {product?.Product?.Name}</span>
                                                    </div>
                                                    <div className="col d-flex align-items-center">
                                                        {product?.DeliveryHour && (
                                                            <span
                                                                className="d-flex justify-content-center align-items-center"
                                                                data-tooltip-place="top" data-tooltip-id="delivery-time"
                                                                data-tooltip-content="Delivery time"
                                                            >
                                                                {iconTime} {product?.DeliveryHour}:{product?.DeliveryMinute}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <Tooltip id="delivery-time" />
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>

                                {/* Comments */}
                                <div className="col-lg-4 col-md-4 col-sm-4">
                                    <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblComments, "Comments")}: &nbsp;</span>
                                    <div>
                                        <pre
                                            style={{ fontFamily: "Barlow, serif", fontWeight: "500", whiteSpace: "break-spaces" }}
                                            dangerouslySetInnerHTML={{ __html: cateringOrder?.CommentHtml?.trim() ? cateringOrder?.CommentHtml : cateringOrder?.Comment ?? "--" }}
                                        />
                                    </div>
                                </div>

                                {/* Internal Comments */}
                                <div className="col-lg-4 col-md-4 col-sm-4">
                                    <span className="fw-bold">{getDynamicLabel(OverviewTranslation?.lblInternalComments, "Internal Comments")}: &nbsp;</span>
                                    <div>
                                        <pre
                                            style={{ fontFamily: "Barlow, serif", fontWeight: "500", whiteSpace: "break-spaces" }}
                                            dangerouslySetInnerHTML={{ __html: cateringOrder?.InternalCommentHtml?.trim() ? cateringOrder?.InternalCommentHtml : cateringOrder?.InternalComment ?? "--" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                )}
            </section>
        </div>
    )
}